import { useSearchParams } from 'react-router-dom';
import { useAppSelector } from '@/shared/store/hooks';
import { PROFILE_TABS } from './ProfilePage.types';
import { OverviewTab } from './tabs/OverviewTab';
import { SecurityTab } from './tabs/SecurityTab';

export function ProfilePage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'overview';
  const setTab = (tab: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', tab);
    setSearchParams(next);
  };

  const permissions = useAppSelector((s) => s.auth.permissions);
  const canSee = (permission?: string) => {
    if (!permission) return true;
    if (!permissions.length) return true;
    return permissions.includes(permission);
  };
  const visibleTabs = PROFILE_TABS.filter((t) => canSee(t.permission));

  return (
    <div className="mx-auto flex w-full max-w-5xl flex-col gap-6">
      <header className="text-left">
        <p className="m-0 text-[11px] font-semibold tracking-[0.12em] text-[var(--dash-brand)] uppercase">
          Account
        </p>
        <h1 className="m-0 mt-1 text-2xl font-semibold tracking-tight text-[var(--dash-ink)]">
          My Profile
        </h1>
      </header>

      <nav className="flex flex-wrap gap-2 rounded-2xl border border-[var(--dash-line)] bg-white px-3 py-2">
        {visibleTabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setTab(tab.key)}
            className={`rounded-xl px-4 py-2 text-sm font-semibold transition ${
              activeTab === tab.key
                ? 'bg-[var(--dash-brand)] text-white shadow-sm'
                : 'text-[var(--dash-muted)] hover:bg-[var(--dash-soft)] hover:text-[var(--dash-ink)]'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      {activeTab === 'overview' ? <OverviewTab /> : null}
      {activeTab === 'security' ? <SecurityTab /> : null}
    </div>
  );
}
